"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var PartnerOfferEditor = /** @class */ (function (_super) {
    __extends(PartnerOfferEditor, _super);
    function PartnerOfferEditor(props) {
        return _super.call(this, props) || this;
    }
    PartnerOfferEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AO = this.props.availOffersList.Subscribe("*", function (id, data) {
            _this.setState({ avail_offers: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    affilate_offer_id: _item.pprogram_offer_id,
                    affilate_offer_title: _item.pprogram_offer_title,
                    avail_offers: []
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Офферы партнера", "Редактировать оффер"]);
                    _this.props.availOffersList.LoadDataByPartnerId(_this.props.rootRecord.key);
                });
            }
        }
        else {
            this.setState({
                affilate_offer_id: 0,
                affilate_offer_title: "",
                avail_offers: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Офферы партнера", "Создать оффер"]);
                _this.props.availOffersList.LoadDataByPartnerId(_this.props.rootRecord.key);
            });
        }
        this.doReSetRules();
    };
    PartnerOfferEditor.prototype.componentWillUnmount = function () {
        this.props.availOffersList.UnSubscribe(this.SID_AO);
    };
    PartnerOfferEditor.prototype.doReSetRules = function () {
        this.setState({
            affilate_offer_rules: { isError: false }
        });
    };
    PartnerOfferEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.affilate_offer_id <= 0) || (this.state.affilate_offer_title.length === 0)) {
            this.setState({ affilate_offer_rules: { isError: true, errorMessage: "Оффер не выбран!" } });
            return false;
        }
        return true;
    };
    PartnerOfferEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                offer_id: this.state.affilate_offer_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер партнера изменен!");
            });
        }
    };
    PartnerOfferEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                offer_id: this.state.affilate_offer_id,
                usr_partner_id: this.props.rootRecord.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер партнера добавлен!");
            });
        }
    };
    PartnerOfferEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PartnerOfferEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый оффер партнера";
        }
        else {
            return "Изменить оффер партнера";
        }
    };
    PartnerOfferEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 280 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер:", placeholder: "Выберите оффер" }, value: { key: this.state.affilate_offer_id, value: this.state.affilate_offer_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        affilate_offer_id: newVal.key,
                        affilate_offer_title: newVal.value,
                        affilate_offer_rules: { isError: false }
                    });
                }, items: this.state.avail_offers, required: true, rules: this.state.affilate_offer_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PartnerOfferEditor;
}(React.Component));
exports.default = PartnerOfferEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/offer/PartnerOfferEditor.tsx
// module id = 2437
// module chunks = 0